import React, { Component } from 'react';

import SwitchDeslizador from '../Miscelanea/ComponenteSwitchDeslizador';
import BarraNavegacion from '../Barras/BarraNavegacion';
import Inicio from '../Bienvenida/Inicio'
import * as RUTAS from '../../compartido/rutas';

import { establecerGalleta, obtenerGalleta } from '../../componentes/Utilidades/gestorCookies';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';

import {
    iniciarSesion
} from '../../redux/CreadorAcciones';

const mapStateToProps = (state) => {

    return {
        sesion: state.sesion
    }

}

const mapDispatchToProps = (dispatch) => ({
    iniciarSesion: (usuario, contrasena) => dispatch(iniciarSesion(usuario, contrasena)),

})

class Principal extends Component {

    render() {
        return (
            <>
                <BarraNavegacion />
                <SwitchDeslizador>
                    <Route exact path="/" component={Inicio} />
                    <Route path={RUTAS.INICIO_BIENVENIDA.ruta} component={Inicio} />
                    <Redirect to={RUTAS.INICIO_BIENVENIDA.ruta} component={Inicio} />
                </SwitchDeslizador>

            </>

        )

    }

}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Principal));